import { assign, keys, pick } from "lodash";

export function updateSharedFields<T extends object, U extends object>(target: T, source: U): void {
  const shared = pick(source, keys(target));
  assign(target, shared);
};
